module.exports = __webpack_public_path__ + "img/logonav.16197597.png";